import { Component, OnInit } from '@angular/core';
import { ConnectionService } from '../../connection.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
	selector: 'app-address',
	templateUrl: './address.component.html',
	styleUrls: ['./address.component.css']
})
export class AddressComponent implements OnInit {
	addHis = []; tokRes = []; proRes = []; voteRes = []; voteData = []; addDet = []; address; addHiscount = 0; ethBrokerage: any; bal: any; tokenbal: any; is_witness: any; create_time: any; addempty = true;
	add: number = 1; inum = '0';
	repAddress: any;
	balance: any ;
	listVoting: any;
	dep: number = 1
	voteCount: any;
	url: any;
	reward: any;
	totalBlocks: any;
	srDetailsList: any;
	isSRexists: any;
	srvoteCount: any;

	constructor(private conn: ConnectionService, private alert: ToastrService, private actRoute: ActivatedRoute, private route: Router,private spinner: NgxSpinnerService) {
		this.repAddress = this.actRoute.snapshot.params['address']
	}

	ngOnInit() {
		this.getBalance(this.repAddress);
		this.getSRVotes(this.repAddress);
		this.getcurrentVotes(this.repAddress);
		this.getReward(this.repAddress);
		this.Srdetails(this.repAddress)
	}

	changeSr(address?:any){
		this.repAddress = address
		this.getBalance(this.repAddress);
		this.getSRVotes(this.repAddress);
		this.getcurrentVotes(this.repAddress);
	  }

	getcurrentVotes(repaddress?:any) {
		this.conn.postUrl('vote/currentVoteByAddress', { address: repaddress }).subscribe((res: any) => {
			if(res.data[0].total){
				this.voteCount = res.data[0].total;
				this.url = res.data[1].url
				this.totalBlocks = res.data[1].totalProduced
			}
			else{
				this.voteCount = 0;
				this.url = res.data[0].url
				this.totalBlocks = res.data[0].totalProduced
			}
		})
	}

	Srdetails(repaddress?:any) {
		// this.spinner.show()
		this.conn.postUrl('superRep/getAllWitnessbyaddress',{address : repaddress}).subscribe(async (res: any) => {
		  this.srvoteCount = res.data;
		//   this.spinner.hide()

		});
	  }

	getReward(repaddress?:any) {
		this.conn.postUrl('contract/getReward', { address: repaddress }).subscribe((res: any) => {
			if (res.status == true) {
				this.reward = res.data
			}
		})
	}

	getBalance(repaddress?:any) {
		this.conn.postUrl('users/srBalance', { address: repaddress }).subscribe((res: any) => {
			this.balance = res.data.userBalance;
		})
	}

	getSRVotes(repaddress?:any) {
		this.conn.postUrl('vote/voteListByAddress', { address: repaddress }).subscribe((res: any) => {
			if(res.success == true){
				this.listVoting = res.data;
			}
			else{
				this.listVoting = ''
			}
		});
	}

	copyText(val: string) {
		let selBox = document.createElement('input');
		selBox.value = val;
		document.body.appendChild(selBox);
		selBox.focus();
		selBox.select();
		document.execCommand('copy');
		document.body.removeChild(selBox);
		// window.scrollTo(0, 0);
		this.alert.success('Copied to the clipboard');
	}
}
